import React from 'react'
import { type StepProps } from '@adsk/napi-shared'
import { HeaderComponent, BodyComponent, FooterComponent } from './components'

export const PROFILE_EDIT_CONFIRMATION_STEP_IDX = 0
const ProfileEditAndConfirmationStep = (): StepProps => {
	return {
		size: 'large',
		root: {
			props: {
				height: 'auto',
			},
		},
		header: {
			props: {
				disableBorder: false,
			},
			content: <HeaderComponent />,
		},
		body: {
			content: <BodyComponent />,
			props: {},
		},
		footer: {
			props: {},
			content: <FooterComponent />,
		},
	}
}

export default ProfileEditAndConfirmationStep
